<template>
  <v-card class="pa-3">
    <h1
      v-if="dataInvalida"
      class="fonte"
    >Não é possível criar um evento nessa data. Pois a data é menor do que permitida.</h1>
    <v-layout v-if="!dataInvalida" row wrap justify-space-between>
      <v-flex xs6>
        <h1 class="fonte text-uppercase">Crie sua campanha</h1>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              box="box"
              :items="getTemplatesCampanha"
              v-model="campanha.template"
              @change="detalhesMailing($event)"
              no-data-text="Nenhuma campanha encontrada"
              item-text="nome"
              item-value="_id"
              label="Escolha o mailing"
              color="teal"
            ></v-select>
            <div v-if="campanha.template">
              <p>
                <v-icon>short_text</v-icon>
                {{`Quantidade de registros: ${detalhesTemplate.qtdLinhas}`}}
              </p>
              <p>
                <v-icon>today</v-icon>
                {{`Gerado em: ${convertDataBr(detalhesTemplate.createdAt)}`}}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 v-if="campanha.template">
            <v-text-field color="teal" box label="Nome da campanha" v-model="campanha.nome"></v-text-field>
          </v-flex>
          <v-flex v-if="campanha.template" xs12>
            <v-textarea
              color="teal"
              box="box"
              label="Insira o texto a ser enviado"
              required="required"
              counter
              :maxlength="getUserLocal.operator === 'chipeira' ? null : 160"
              :hint="getUserLocal.operator === 'chipeira' ? null : 'Apenas 160 caracteres são permitidos'"
              v-model="campanha.mensagem"
            ></v-textarea>
            <p class="grey--text text--darken-1 body-2">
              <v-icon>warning</v-icon>Não são permitidos caracteres especiais
            </p>
          </v-flex>
          <v-flex xs12 v-if="campanha.template">
            <v-menu
              ref="menu"
              v-model="menuHora"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="hora"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="hora"
                  label="Horário"
                  prepend-icon="access_time"
                  box
                  readonly
                  v-on="on"
                  color="teal"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menuHora"
                v-model="hora"
                min="0:00"
                max="23:59"
                format="24hr"
                scrollable
                color="fundo"
                :allowed-hours="allowedHours"
                :allowed-minutes="allowedMinutes"
                @click:hour="pegaHora($event)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="teal" @click="menuHora = false">Cancelar</v-btn>
                <v-btn flat color="teal" @click="$refs.menu.save(hora)">OK</v-btn>
              </v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex mt-3 v-if="campanha.template">
            <v-btn
              :loading="isLoadingSendCampanha"
              :disabled="!campanha.nome || !campanha.mensagem || !hora || isLoadingSendCampanha"
              color="fundo"
              @click="sendCadastroCampanha()"
              block
              large
              round
            >
              Agendar campanha
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>cached</v-icon>
                </span>
              </template>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6 pl-3>
        <v-card
          v-if="campanha.mensagem"
          style="position: absolute; bottom: 210px; right: 72px; z-index:1000; border-radius:10px; background-color:#D1E2FC; max-width: 232px;"
          class="pa-1"
        >
          <span class="font-weight-bold" style="color: #3E6DB7">{{getSlug(campanha.mensagem)}}</span>
        </v-card>
        <v-img
          class="pt-3 mt-5"
          src="./../../../../src/assets/android.png"
          aspect-ratio="0.6"
          contain
        ></v-img>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-btn flat color="teal" @click="$emit('closeModal'), limpaCampanha()">Sair</v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
import moment from "moment";
import * as helpers from "./../../../helpers/helpers";
import makeSlug from "./../../../helpers/makeSlug";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["novaCampanha", "dataInvalida", "data", "campanha"],
  data() {
    return {
      menuHora: false,
      detalhesTemplate: {},
      hora: "",
      horaSelected: null,
      isLoadingSendCampanha: false
      /*campanha: {
                dataInicial: '',
                mensagem: '',
                template: '',
                nome: ''
            },*/
    };
  },
  computed: {
    ...mapGetters(["getTemplatesCampanha", "getAgendamentos", "getChildren", "getUserLocal"])
  },
  methods: {
    ...mapActions([
      "arquivos_sendCampanha",
      "arquivos_getArquivoTemplateCampanha",
      "arquivos_getAgendamentos",
      "arquivos_cancelaCampanha"
    ]),
    limpaCampanha() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    convertDataBr(data) {
      return helpers.getDateTimeZoneBR(data);
    },
    pegaHora(evento) {
      this.horaSelected = +evento;
    },
    allowedHours(v) {
      if (this.data == moment(new Date()).format("YYYY-MM-DD")) {
        return v >= new Date().getHours();
      } else return v >= 0 && v <= 23;
      /*console.log('hora', v)
            return v*/
    },
    allowedMinutes(v) {
      if (this.data == moment(new Date()).format("YYYY-MM-DD")) {
        if (new Date().getHours() == this.horaSelected)
          return v >= new Date().getMinutes();
        else return true;
      } else return true;
      /*console.log('minuto', v)
            return v*/
    },
    /*mesAtual(mes)
        {
            return helpers.nomeMes(mes)
        },*/
    async sendCadastroCampanha() {
      this.campanha.dataInicial = this.data + " " + this.hora;

      this.campanha.dataInicial = moment(this.campanha.dataInicial).toDate();

      console.log('dtinicial: ', this.campanha.dataInicial, ' moment: ', moment(this.campanha.dataInicial))
      //console.log(this.campanha)

      if (this.campanha.nome && this.campanha.mensagem && this.hora) {
        this.isLoadingSendCampanha = true;
        let r = await this.arquivos_sendCampanha(this.campanha);
        this.$eventHub.emit("snackBar", { message: r.mensagem });
        let campanha = {
          dataInicial: "",
          hora: "",
          data: "",
          mensagem: "",
          template: ""
        };
        this.$emit("update:campanha", campanha);
        this.arquivos_getAgendamentos(moment(new Date()).format("MM"));
        Object.assign(this.$data, this.$options.data.apply(this));
        this.isLoadingSendCampanha = false;
        this.$emit("closeModal");
      } else {
        this.isLoadingSendCampanha = false;
        this.$eventHub.emit("snackBar", {
          message: "Falta um campo ser preenchido"
        });
      }
    },
    detalhesMailing(id) {
      this.detalhesTemplate = this.getTemplatesCampanha.find(t => t._id == id);
      return this.detalhesTemplate;
    },

    getSlug(text) {
      return makeSlug(text);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/mensagens/NovaCampanha.vue